module.exports = __webpack_public_path__ + "img/test2222.774297ba.jpg";